import { applyDataTestId } from "@/utils/testUtils";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";
import pom from "@/utils/pom";
import { useCurrency } from "@/app/providers/currencyContext";
import { Item } from "@/dto/item";
import { Merchant } from "@/dto/merchant";

interface AddToCartContentProps {
  merchant: Merchant;
  selectedItem: Item;
  totalPrice: number;
  isBusinessOpen: boolean;
}

export const AddToCartContent = ({
  merchant,
  selectedItem,
  totalPrice,
  isBusinessOpen,
}: AddToCartContentProps) => {
  const t = useTranslations("AddToCardContent");
  const { format } = useCurrency();

  const pathName = usePathname();
  const isShopPage: boolean = pathName?.includes("shop") || false;

  if (
    (!isBusinessOpen &&
      isShopPage &&
      merchant.isService &&
      merchant.isHybrid) ||
    selectedItem?.available === false
  ) {
    return (
      <div className="text-[#373737] text-[15px]">
        <p>{t("sorryItemUnavailable")}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-row px-6 items-center justify-between">
      <span>{t("addToCart")}</span>
      <span data-testid={applyDataTestId(pom.itemModal.totalPrice)}>
        {format(totalPrice)}
      </span>
    </div>
  );
};
